module.exports = __webpack_public_path__ + "static/image/sign/kimbeomjun.png?25043099";